import { makeStyles } from "@material-ui/styles";

const MatchEditStyles = makeStyles(() => ({
	autoComplete: {
		marginTop: 20
	},
	form: {
		lineHeight: 5,
		justifyContent: "center"
	},
	header: {
		color: "#5B5B5B",
		fontSize: 12,
		padding: "2px 8px",
		width: 46
	},
	rankHeader: {
		marginLeft: 50
	},
	teams: {
		display: "inline-flex"
	},
	score: {
		maxWidth: 50,
		padding: "0 5px",
		height: 56,
		"& input": {
			"&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
				"-webkit-appearance": "none",
				display: "none"
			}
		}
	},
	notchedOutline: {
		borderColor: "red"
	},
	dashed: {
		boxSizing: "border-box",
		color: "#B2B2B2",
		height: 56,
		width: 40,
		border: "1px dashed #B2B2B2",
		borderRadius: 4,
		margin: "0 5px"
	},
	tiebreak: {
		height: 12,
		width: 9.81,
		letterSpacing: 0,
		lineHeight: 12,
		marginLeft: -8,
		padding: 9,
		paddingRight: 0,
		" & p": {
			color: "#5B5B5B",
			fontFamily: "Roboto",
			fontSize: "0.745rem !important"
		}
	},
	chip: {
		maxWidth: 145
	},
	errorMessage: {
		height: "50px",
		overflow: "hidden"
	},
	playerContainer: {
		display: "flex"
	},
	durationParent: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-start",
		padding: "0px 20px 0px 20px"
	},
	durationPicker: {
		maxWidth: "200px"
	}
}));

export default MatchEditStyles;
